import { render, staticRenderFns } from "./RecordAudioAnswer.vue?vue&type=template&id=6c954d92"
import script from "./RecordAudioAnswer.vue?vue&type=script&lang=js"
export * from "./RecordAudioAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports